import * as React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { h600 } from '@helpcenter/styles/src/fonts';
import * as grid from '@helpcenter/styles/src/grid';
import { ThemedLink } from '@helpcenter/themed-link';
import ErrorIcon from 'assets/images/error.react.svg';
import { useIntl } from 'react-intl';
import Heading from '@atlaskit/heading';
import { Box, Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import { UseTypographyMigratedComponent } from '@atlassian/help-center-common-util/enable-typography-migration';

import messages from './messages';

const LEARN_MORE_LINK =
    'https://support.atlassian.com/jira-service-management-cloud/docs/test-single-sign-on-for-customer-login/';

const CaSsoTestModeErrorPage = () => {
    const { formatMessage } = useIntl();

    return (
        <Container data-test-id="ca-sso-test-mode-error-screen-container">
            <FireScreenEventOnMount />
            <IconContainer>
                <ErrorIcon />
            </IconContainer>

            <UseTypographyMigratedComponent
                migratedComponent={
                    <Box paddingBlockEnd="space.050">
                        <Heading size="medium">{formatMessage(messages.title)}</Heading>
                    </Box>
                }
            >
                <Title>{formatMessage(messages.title)}</Title>
            </UseTypographyMigratedComponent>
            <UseTypographyMigratedComponent
                migratedComponent={<Text>{formatMessage(messages.instructionMessage)}</Text>}
            >
                {/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
                <p>{formatMessage(messages.instructionMessage)}</p>
            </UseTypographyMigratedComponent>
            <ThemedLink actionSubjectId="learnMoreSsoTestMode" href={LEARN_MORE_LINK} target="_blank">
                {formatMessage(messages.learnMoreLinkLabel)}
            </ThemedLink>
        </Container>
    );
};

export default CaSsoTestModeErrorPage;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Container = styled.div`
    text-align: center;

    > * {
        margin-bottom: ${token('space.300', '24px')};
    }

    > *:last-child {
        margin-bottom: 0;
    }
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Title = styled.div`
    ${h600};
    margin-bottom: ${token('space.050', '4px')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const IconContainer = styled.div`
    width: ${grid.multiple(10.5).px};
    margin: 0 auto ${token('space.300', '24px')} auto;
`;
